import { useMutation, useQueryClient } from "@tanstack/react-query";
import { replayOutboxEvent } from "../services/outboxApi";
import { useToast } from "../contexts/ToastContext";

export const useReplayOutboxEvent = () => {
  const queryClient = useQueryClient();
  const { addToast } = useToast();

  return useMutation({
    mutationFn: (eventId: string) => replayOutboxEvent(eventId),
    onSuccess: () => {
      addToast({ message: "Event przywrócony do kolejki", type: "success" });
      // Invalidate and refetch dashboard data
      queryClient.invalidateQueries({ queryKey: ["outboxDashboard"] });
    },
    onError: (error: Error) => {
      addToast({ message: error.message || "Błąd podczas replay eventu", type: "error" });
    },
  });
};

export default useReplayOutboxEvent;
